export const TxPanelSkeleton = () => (
  <div role="status" aria-label="Loading transaction details" className="flex flex-col gap-4">
    <span className="sr-only">Loading transaction details</span>
    <div aria-hidden="true" className="flex animate-pulse flex-col gap-4 motion-reduce:animate-none">
      <div className="h-20 rounded-2xl border bg-surface" />
      <div className="h-12 rounded-full border bg-surface lg:h-14" />
      <div className="flex flex-col gap-4 rounded-2xl border bg-surface p-4">
        <div className="h-4 w-2/3 rounded bg-border" />
        <div className="h-10 w-1/2 rounded bg-border" />
        <div className="h-4 w-1/3 rounded bg-border" />
      </div>
      <div className="h-13 rounded-full border bg-surface" />
    </div>
  </div>
)
